import { APIResponse, Notification } from '../types';

export const APIResponseToNotification = (item: APIResponse): Notification => {
  return {
    clientId: item.client_id,
    clientName: undefined,
    createdTimestamp: item.timestamp,
    dashboardAction: {
      href: item.dashboard_action.href,
      type: item.dashboard_action.type.toLowerCase(),
    },
    entityId: item.entity_id,
    entityName: undefined,
    eventId: item.event_id,
    isRead: item.is_read,
    message: item.message,
    notificationType: item.notification_type,
    receivedTimestamp: item.timestamp,
    title: item.title,
    userId: item.user_id,
  };
};
